
import XButton from 'vux/src/components/x-button/index.vue'
import Icon from 'vux/src/components/icon/index.vue'
import FormPreview from 'vux/src/components/form-preview/index.vue'
import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'
import Confirm from 'vux/src/components/confirm/index.vue'

export default {
name: 'result',
props: {
resultMsg: {}
},
directives: {
TransferDom
},
components: {
XButton, Icon, FormPreview, Flexbox, FlexboxItem, Confirm
},
data () {
return {
}
},
methods: {
resetChild () {
this.$parent.reset()
},
onConfirm (type) {
let info = {
msg: '',
isEdit: true
}

if (type === 'edit') {
info.msg = '请重新填写'
} else if (type === 'cancel') {
info.msg = '取消成功'
}
this.$parent.onConfirm(info)
},
onCancel () {
this.$parent.onCancel()
}
}
}



// WEBPACK FOOTER //
// ./src/components/result.vue